module.exports = __webpack_public_path__ + "static/logo-table-cc9038948117f6fa52321433c62bb7b1.svg";